import { render, staticRenderFns } from "./DetectionSetForm.vue?vue&type=template&id=77a19993&scoped=true&"
import script from "./DetectionSetForm.vue?vue&type=script&lang=js&"
export * from "./DetectionSetForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a19993",
  null
  
)

export default component.exports